<template>
  <div class="event-banner" :style="bannerStyles">
    <img class="banner-circle" :src="$assets.image['banner_circle.png']" alt="" />
    <div class="banner-content">
      <h1 class="title">{{ evEvent.title }}</h1>
      <p class="subtitle">HUB Facilitator Training | {{ displayDate }}</p>
      <div class="line" />
      <p v-for="paragraph in bannerDescription" :key="paragraph" class="event-description">
        {{ paragraph }}
      </p>
      <div class="buttons">
        <RegisterOrVideoButton :evEventOrCourse="evEvent" />
        <MoreInfoButton :evEventOrCourse="evEvent" @click="moreInfo" />
      </div>
    </div>

    <MoreInfoPopup v-if="showMoreInfo" :evEvent="evEvent" @close="showMoreInfo = false" />
  </div>
</template>

<script setup>
import { ref, computed } from 'vue';

import $assets from '@/assets';
import MoreInfoButton from '@/components/event/MoreInfoButton.vue';
import MoreInfoPopup from '@/components/event/MoreInfoPopup.vue';
import RegisterOrVideoButton from '@/components/event/RegisterOrVideoButton.vue';

const props = defineProps({
  evEvent: {
    type: Object,
    default: () => ({}),
  },
});

const showMoreInfo = ref(false);

const bannerStyles = computed(() => {
  return {
    backgroundImage: `url(${props.evEvent.hero_banner})`,
  };
});

const displayDate = computed(() => {
  if (!props.evEvent.start_date) return 'Coming Soon';

  const options = { dateStyle: 'long' };
  const startDate = props.evEvent.start_date.toLocaleString('en-CA', options);

  return startDate;
});

const bannerDescription = computed(() => {
  return props.evEvent.info_description.split(/[\r\n]+/).map((line) => line);
});

function moreInfo() {
  showMoreInfo.value = true;
}
</script>

<style scoped>
.event-banner {
  display: none;

  position: relative;
  width: 100%;
  height: 463px;

  overflow: hidden;
  background-size: cover;
}

/** Larger devices and Landscape mobile */
@media only screen and (min-width: 601px) {
  .event-banner {
    display: flex;
    flex-direction: row;
    align-items: center;
  }
}

.banner-circle {
  position: absolute;
  top: 50%;
  left: 0%;
  transform: translateY(-50%);
  width: 65em;
}

.banner-content {
  position: relative;
  /* top: 6em; */
  left: 7em;
  width: 30.3em;

  color: white;

  font-family: Helvetica;
  font-size: 1em;
}

.banner-content .line {
  width: 80%;
  border-top: 1px solid currentColor;
}

.banner-content > h1 {
  margin-top: 0;
  font-size: 1.6em;
  font-weight: normal;
  color: inherit;
}

.buttons {
  width: 20em;

  display: flex;
  flex-direction: row;
  justify-content: flex-start;
}
</style>
